import React, { createContext, useContext, useState, useCallback } from 'react';

// Create Tab Context
const TabContext = createContext();

// Tab Context Provider
export const TabProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState({
    level: 'msp', // 'msp' or 'organization'
    tabIndex: 0,
    tabName: 'Dashboard'
  });

  const updateActiveTab = useCallback((level, tabIndex, tabName) => {
    setActiveTab({ level, tabIndex, tabName });
  }, []);

  return (
    <TabContext.Provider value={{ activeTab, updateActiveTab }}>
      {children}
    </TabContext.Provider>
  );
};

// Custom hook to use Tab Context
export const useTab = () => {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTab must be used within a TabProvider');
  }
  return context;
};

export default TabContext; 